import { useState } from 'react'
import DataTable from '../../../common/data-table/DataTable'
import PageHeader from '../../../layout/page/PageHeader'
import { FilterMatchMode } from 'primereact/api'
import { useAppSelector } from '../../../../store/hooks'
import { ButtonGroup } from 'react-bootstrap'
import DeleteDialog from '../../../common/dialogs/DeleteDialog'
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

const Navigation = () => {
    const theme = useAppSelector((state) => state.theme.theme)
    const [refreshTable, setRefreshTable] = useState(false)

    const actionsBodyTemplate = (rowData) => {
        return (
            <ButtonGroup size="sm">
                <DeleteDialog
                    url={'/administration/navigation/delete/' + rowData.id}
                    record={rowData}
                    deletedCallback={() => setRefreshTable(true)}
                    message={
                        <>
                            <p className="mb-3 pb-3 border-bottom">
                                Are you sure you want to delete navigation:
                                <strong> {rowData.name}</strong>?
                            </p>
                        </>
                    }
                />
                <NavLink
                    to={'/administration/navigation/view/' + rowData.id}
                    className="btn btn-outline-primary ms-1"
                >
                    <FontAwesomeIcon icon={faEdit} />
                </NavLink>
            </ButtonGroup>
        )
    }

    return (
        <>
            <PageHeader
                icon="bars-staggered"
                subtitle="Build and organise site navigation menus"
                gradient="linear-gradient(135deg, #ec4899, #db2777)"
                header="Navigation"
                buttons={[
                    {
                        variant: theme === 'dark' ? 'dark' : 'light',
                        label: 'Back to Administration',
                        icon: 'fa-solid fa-arrow-left',
                        url: '/administration',
                    },
                    {
                        variant: 'success',
                        label: 'Create New',
                        icon: 'fa-solid fa-plus',
                        url: '/administration/navigation/new',
                    },
                ]}
            />
            <DataTable
                refreshTable={refreshTable}
                config={{
                    dataRoute: '/administration/navigation',
                    first: 0,
                    rows: 10,
                    page: 0,
                    sortField: 'name',
                    sortOrder: -1,
                    sortMode: 'multiple',
                    filters: {
                        global: {
                            value: null,
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                        name: {
                            value: '',
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                        code: {
                            value: '',
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                        updated_at: {
                            value: '',
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                    },
                    filterDisplay: 'menu',
                }}
                columns={[
                    {
                        field: 'name',
                        header: 'Name',
                        sortable: true,
                        filter: true,
                        filterPlaceholder: 'Search',
                    },
                    {
                        field: 'code',
                        header: 'Code',
                        sortable: true,
                        filter: true,
                        filterPlaceholder: 'Search',
                        fixedCenter: true,
                        alignHeader: 'center',
                        headerStyle: {
                            width: '7.5rem',
                            minWidth: '7.5rem',
                            maxWidth: '7.5rem',
                        },
                        style: {
                            width: '7.5rem',
                            minWidth: '7.5rem',
                            maxWidth: '7.5rem',
                        },
                    },
                    {
                        field: 'id',
                        header: 'Actions',
                        sortable: false,
                        body: actionsBodyTemplate,
                        alignHeader: 'center',
                        headerStyle: {
                            maxWidth: '1.2rem',
                            textAlign: 'center',
                        },
                        style: {
                            maxWidth: '1.2rem',
                            textAlign: 'center',
                        },
                        toggleVisibility: false,
                    },
                ]}
                globalFilterFields={['name', 'code', 'updated_at']}
            />
        </>
    )
}

export default Navigation
